{
    "app": {
        "title": "Dashbal",
        "common": {
            "defaultStoreName": "Your Store",
            "loading": "Loading...",
            "unknown": "Unknown"
        },
        "status": {
            "checking": "Checking connection status...",
            "settingUpTitle": "Setting Up Your Connection",
            "settingUpDescription": "We're connecting your store to Dashbal. This usually takes just a few seconds.",
            "syncInProgress": "Data synchronization is in progress. This may take a few minutes depending on the size of your store.",
            "dashbalAccount": "Dashbal Account",
            "lastSynced": "Last Synced",
            "lastSyncedJustNow": "Just now",
            "lastSyncedMinute": "{{count}} minute ago",
            "lastSyncedMinute_plural": "{{count}} minutes ago",
            "lastSyncedHour": "{{count}} hour ago",
            "lastSyncedHour_plural": "{{count}} hours ago",
            "lastSyncedNever": "Never",
            "errorTitle": "Connection Error",
            "errorDescription": "There was a problem connecting your store. Please try again or contact support.",
            "notConnectedTitle": "Store Not Connected",
            "notConnectedDescription": "We couldn't automatically connect your store. Please try again. If the problem persists, contact support.",
            "active": "Active",
            "syncing": "Syncing",
            "error": "Error",
            "disconnected": "Disconnected",
            "pending": "Pending",
            "contactSupport": "contact support"
        },
        "connectionStatus": {
            "title": "Connection Status",
            "store": "Store:"
        },
        "actions": {
            "openDashboard": "Open Dashbal Dashboard",
            "documentation": "Documentation",
            "retrySync": "Retry Sync",
            "retrySetup": "Try Again",
            "disconnect": "Disconnect Store",
            "changePlan": "Change plan"
        },
        "disconnect": {
            "title": "Disconnect Store",
            "warning": "Are you sure you want to disconnect your store? This will stop data synchronization. You can reconnect at any time by reinstalling the app.",
            "confirm": "Disconnect",
            "cancel": "Cancel",
            "accountLabel": "Account: {{email}}",
            "error": "Failed to disconnect store"
        },
        "setup": {
            "title": "How It Works",
            "step1": "Enter your Dashbal account email to link your store",
            "step2": "Enter the 6-digit authorization code sent to your email",
            "step3": "Your data will start syncing automatically once connected"
        },
        "whatNext": {
            "title": "What You Can Do",
            "description": "Your store data is syncing with Dashbal. Open the dashboard to access real-time analytics, financial reports, and business insights."
        },
        "quickLinks": {
            "title": "Quick Links"
        },
        "settings": {
            "title": "Settings",
            "description": "Manage your store connection and integration settings.",
            "billedViaWebsite": "Billing is managed on your Dashbal account."
        },
        "support": {
            "title": "Support",
            "contactSupport": "Contact Support"
        },
        "errors": {
            "connectionCheckFailed": "Failed to check connection status",
            "shopNotDetected": "Could not detect your shop. Please access this app from Shopify Admin.",
            "setupTimeout": "Connection setup timed out. Please try again.",
            "setupFailed": "Failed to set up connection",
            "emailRequired": "Email is required.",
            "otpRequired": "Email and authorization code are required.",
            "otpSendFailed": "Failed to send authorization code.",
            "verifyFailed": "Failed to verify code and connect"
        },
        "notConnected": {
            "title": "Setup Dashbal Account",
            "enterEmail": "Enter your email to connect this store. We'll link your Dashbal account — or create one for you if you don't have it yet.",
            "checkEmail": "Check your email inbox for the 6-digit authorization code.",
            "checkEmailNewAccount": "We sent a 6-digit code to your email. Enter it to create your Dashbal account and connect this store.",
            "emailLabel": "Dashbal Email",
            "emailHelp": "We will send an authorization code to verify this email.",
            "otpLabel": "6-Digit Authorization Code",
            "otpHelp": "Enter the code sent to your email.",
            "requestButton": "Send Verification Code",
            "linkButton": "Link Account",
            "verifyButton": "Verify and Connect",
            "cancelButton": "Change Email"
        }
    },
    "billing": {
        "loading": "Loading plans…",
        "pickerTitle": "Choose your Dashbal plan",
        "subscribe": "Subscribe",
        "continueFree": "Continue with Free",
        "freeBadge": "No payment required",
        "freePrice": "Free forever",
        "month": "month",
        "trialBadge": "{{days}}-day free trial",
        "includedStores": "Includes up to {{count}} connected Shopify store",
        "includedStores_plural": "Includes up to {{count}} connected Shopify stores",
        "legalCharge": "Charges appear on your Shopify invoice. By subscribing you agree to the Dashbal Terms of Service.",
        "activating": "Activating your subscription…",
        "activationFailed": "We couldn't confirm your subscription. Please refresh in a moment.",
        "retry": "Retry",
        "openDashbal": "Open Dashbal",
        "activeBadge": "Active",
        "billingViaShopify": "Billed via Shopify",
        "currentPlanBadge": "Current plan",
        "previousPlanBadge": "Your previous plan",
        "resubscribe": "Resubscribe",
        "alreadyOnPlan": "Already on this plan",
        "backToApp": "Back to app",
        "websiteSubscriptionTitle": "You're all set",
        "websiteSubscriptionActive": "Your subscription is active on your Dashbal account. No payment is needed in this app — this store is covered by your existing plan.",
        "activeOnOtherStore": "This Dashbal account already has an active subscription on another Shopify store. Cancel it there before subscribing on this store."
    }
}